<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_NUMBER' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.BRANCH_NAME' | translate }}
				</td>
				<td
					*ngIf="payoutFilter.activeTab == 1"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.SERVICEPROVIDER_NAME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.AMOUNT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_CREATION_DATE' | translate }}
				</td>
				<td
					*ngIf="payoutFilter.activeTab == 2"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_DATE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PAYOUT.PAYOUT_LIST.PAYMENT_METHOD' | translate }}
				</td>
				<td class="w-[20px]"></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let payout of listData
						| paginate
							: {
									itemsPerPage: payoutFilter?.paging?.pageSize,
									currentPage: payoutFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != listData?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					class="text-font-16 leading-[22px] bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12">
						#{{ payout?.id }}
					</h1>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ payout?.branchName }}
				</td>
				<td
					*ngIf="payoutFilter.activeTab == 1"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ payout?.organizationName }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ payout?.requiredAmount }}
					{{
						translate.currentLang == 'en'
							? payout?.currency?.name?.en
							: payout?.currency?.name?.ar
					}}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ payout?.transactionDate | date : 'dd/MM/yyyy , hh:mm a' : 'UTC' }}
				</td>
				<td
					*ngIf="payoutFilter.activeTab == 2"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ payout?.actionDate | date : 'dd/MM/yyyy , hh:mm a' : 'UTC' }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<app-status
						*ngIf="payout?.payoutMethodId != null"
						[enumData]="PaymentPayoutStatus"
						[statusValue]="payout?.payoutMethodId"
					>
					</app-status>
					<p
						*ngIf="payout?.payoutMethodId == null"
						class="text-medium-gray py-[6px] px-[12px] text-font-16 leading-[22px]"
					>
						---
					</p>
				</td>

				<td
					(click)="
						payoutFilter.activeTab == 1
							? openSelect(payout.id)
							: openDetails(payout.id)
					"
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap relative"
				>
					<button
						[disabled]="payout?.payoutMethodId == null"
						class="inline-block max-mobile:w-[20px] w-[16px] text-end"
					>
						<img
							(mouseout)="inCompleteDataHover = false; hoverId = null"
							(mouseover)="inCompleteDataHover = true; hoverId = payout.id"
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</button>
					<div
						*ngIf="payout?.payoutMethodId == null && hoverId == payout?.id"
						class="absolute bg-main-color-black px-[16px] py-12px text-off-white text-font-14 rounded-[4px] max-w-[344px] top-[5px] right-[55px] z-10"
					>
						{{ 'PAYOUT.PAYOUT_LIST.INFO_MISSING' | translate }}
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>
